// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-info-wrapper[data-v-7b89449e]{display:flex;flex-direction:column;font-size:22px;text-align:center}.table-info-wrapper .title-label[data-v-7b89449e]{color:var(--7783d679)}.table-info-wrapper .value[data-v-7b89449e]{color:#000}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
